@if (items) {
  <div class="row align-top">
    <div class="col-md-1"></div>
    <div
    [class]="
      scaling && items.length < 4
        ? items.length < 3
          ? 'col-md-4'
          : 'col-md-6'
        : 'col-md-11'
    "
      >
      <ul
        class="base-sequence"
        [ngClass]="{ readOnly: readOnly, notActive: notActive }"
        >
        @for (detail of items; track detail; let index = $index) {
          <li
            class="base-timeline__item"
        [ngClass]="
          (
            detail.index !== undefined
              ? detail.index === current
              : current === index
          )
            ? 'base-timeline__item--active'
            : index < current
            ? 'base-timeline__item--past'
            : ''
        "
            (click)="onClick(detail)"
          ></li>
        }
      </ul>
    </div>
  </div>
}
